var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { action: _vm.action, target: "_blank", method: "GET" },
      on: { submit: _vm.consultar }
    },
    [
      _c(
        "div",
        { staticClass: "layout" },
        [
          _c("div", { staticClass: "layout__header" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "layout__controls" }, [
              _c("div", { staticClass: "form-inline" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn-info",
                    attrs: { type: "submit", name: "consultar", value: "C" },
                    on: { click: _vm.clickConsultar }
                  },
                  [
                    _c("i", { staticClass: "fa fa-search" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Consultar")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-bus200",
                    attrs: { type: "submit", name: "consultar", value: "E" },
                    on: { click: _vm.clickExcel }
                  },
                  [
                    _c("i", { staticClass: "fa fa-file-excel-o" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Imprimir Excel")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-success",
                    attrs: { type: "submit", name: "consultar", value: "X" },
                    on: { click: _vm.clickXml }
                  },
                  [
                    _c("i", { staticClass: "fa fa-file" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Descargar XML Autorizados")])
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field select2" }, [
                    _c(
                      "div",
                      { staticClass: "select2-field" },
                      [
                        _c("v-select", {
                          attrs: {
                            options: _vm.listaTiposComprobante,
                            label: "descripcion",
                            id: "tipoComprobante",
                            placeholder: "Seleccione..."
                          },
                          on: { input: _vm.cargarPuntosEmision },
                          model: {
                            value: _vm.selectedTipoComprobante,
                            callback: function($$v) {
                              _vm.selectedTipoComprobante = $$v
                            },
                            expression: "selectedTipoComprobante"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "tipoComprobante" } }, [
                          _vm._v("Tipo de comprobante")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.tipoComprobante,
                              expression: "form.tipoComprobante"
                            }
                          ],
                          attrs: { type: "hidden", name: "tipoComprobante" },
                          domProps: { value: _vm.form.tipoComprobante },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "tipoComprobante",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field select2" }, [
                    _c(
                      "div",
                      { staticClass: "select2-field" },
                      [
                        _c("v-select", {
                          attrs: {
                            options: _vm.puntosEmision,
                            label: "descripcion",
                            id: "puntosEmision",
                            placeholder: "Seleccione..."
                          },
                          on: { input: _vm.setearEstadosComprobante },
                          model: {
                            value: _vm.selectedPuntoEmision,
                            callback: function($$v) {
                              _vm.selectedPuntoEmision = $$v
                            },
                            expression: "selectedPuntoEmision"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "puntosEmision" } }, [
                          _vm._v("Puntos de emisión")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.puntoEmision,
                              expression: "form.puntoEmision"
                            }
                          ],
                          attrs: { type: "hidden", name: "puntoEmision" },
                          domProps: { value: _vm.form.puntoEmision },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "puntoEmision",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-inline" }, [
                    _c("label", { attrs: { for: "comprobantes" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.filtro,
                            expression: "form.filtro"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          name: "filtro",
                          id: "comprobantes",
                          value: "C"
                        },
                        domProps: { checked: _vm._q(_vm.form.filtro, "C") },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(_vm.form, "filtro", "C")
                            },
                            _vm.changeLogs
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Comprobantes")])
                    ]),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "logs" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.filtro,
                            expression: "form.filtro"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          name: "filtro",
                          id: "logs",
                          value: "L"
                        },
                        domProps: { checked: _vm._q(_vm.form.filtro, "L") },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(_vm.form, "filtro", "L")
                            },
                            _vm.changeLogs
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Logs")])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field select2" }, [
                    _c(
                      "div",
                      { staticClass: "select2-field" },
                      [
                        _c("v-select", {
                          attrs: {
                            id: "vendedor",
                            options: _vm.vendedores,
                            label: "nombre"
                          },
                          on: { input: _vm.inputVendedor },
                          model: {
                            value: _vm.selectedVendedor,
                            callback: function($$v) {
                              _vm.selectedVendedor = $$v
                            },
                            expression: "selectedVendedor"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "vendedor" } }, [
                          _vm._v("Vendedor")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.vendedorId,
                              expression: "form.vendedorId"
                            }
                          ],
                          attrs: { type: "hidden", name: "vendedorId" },
                          domProps: { value: _vm.form.vendedorId },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "vendedorId",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "###-###-#########",
                              expression: "'###-###-#########'"
                            }
                          ],
                          attrs: {
                            name: "numeroInicial",
                            placeholder: "# Comp (rango inicial)",
                            id: "numeroInicial"
                          },
                          model: {
                            value: _vm.form.numeroInicial,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "numeroInicial", $$v)
                            },
                            expression: "form.numeroInicial"
                          }
                        },
                        [_vm._v("Número de comp.")]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("label", { attrs: { for: "filtrarPorRangos" } }, [
                    _c("p", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.filtrarPorRangos,
                            expression: "form.filtrarPorRangos"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          name: "filtrarPorRangos",
                          id: "filtrarPorRangos"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.form.filtrarPorRangos)
                            ? _vm._i(_vm.form.filtrarPorRangos, null) > -1
                            : _vm.form.filtrarPorRangos
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.form.filtrarPorRangos,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.form,
                                    "filtrarPorRangos",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.form,
                                    "filtrarPorRangos",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.form, "filtrarPorRangos", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Filtrar por rangos de número")])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.filtrarPorRangos,
                        expression: "form.filtrarPorRangos"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c("div", { staticClass: "form-field" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "input-field",
                            {
                              directives: [
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: "###-###-#########",
                                  expression: "'###-###-#########'"
                                }
                              ],
                              attrs: {
                                name: "numeroFinal",
                                placeholder: "(Para filtrar por rangos)",
                                id: "numeroFinal"
                              },
                              model: {
                                value: _vm.form.numeroFinal,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "numeroFinal", $$v)
                                },
                                expression: "form.numeroFinal"
                              }
                            },
                            [_c("span", [_vm._v("Número límite comp.")])]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field select2" }, [
                    _c(
                      "div",
                      { staticClass: "select2-field" },
                      [
                        _c("v-select", {
                          attrs: {
                            options: _vm.estadosComprobante,
                            label: "value",
                            id: "estados",
                            placeholder: "Seleccione..."
                          },
                          on: { input: _vm.inputEstadoComprobante },
                          model: {
                            value: _vm.selectedEstadoComprobante,
                            callback: function($$v) {
                              _vm.selectedEstadoComprobante = $$v
                            },
                            expression: "selectedEstadoComprobante"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "estados" } }, [
                          _vm._v("Estados de comprobante")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          attrs: { type: "hidden", name: "estadoComprobante" },
                          domProps: { value: _vm.form.estadoComprobante }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.form.todos,
                        expression: "!form.todos"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c("div", { staticClass: "form-field" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                disabled: _vm.form.idCliente !== "",
                                name: "numeroIdentificacion",
                                id: "numeroIdentificacion",
                                placeholder: "##########"
                              },
                              model: {
                                value: _vm.form.numeroIdentificacion,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "numeroIdentificacion",
                                    $$v
                                  )
                                },
                                expression: "form.numeroIdentificacion"
                              }
                            },
                            [_c("span", [_vm._v("Número de identificación")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.form.idCliente === "",
                                  expression: "form.idCliente === ''"
                                }
                              ],
                              staticClass: "btn-success",
                              attrs: { type: "button" },
                              on: { click: _vm.cargarPersona }
                            },
                            [_c("i", { staticClass: "fa fa-check" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.form.idCliente !== "",
                                  expression: "form.idCliente !== ''"
                                }
                              ],
                              staticClass: "btn-danger",
                              attrs: { type: "button" },
                              on: { click: _vm.quitarCliente }
                            },
                            [_c("i", { staticClass: "fa fa-ban" })]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.form.todos,
                        expression: "!form.todos"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c("div", { staticClass: "form-field" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                name: "nombreCliente",
                                readonly: "",
                                id: "nombreCliente",
                                placeholder: "Seleccione..."
                              },
                              model: {
                                value: _vm.form.nombreCliente,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "nombreCliente", $$v)
                                },
                                expression: "form.nombreCliente"
                              }
                            },
                            [_c("span", [_vm._v("Persona")])]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            attrs: { type: "hidden", name: "idCliente" },
                            domProps: { value: _vm.form.idCliente }
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn-info",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.$modal.show("cliente")
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-search" })]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-8" }, [
                  _c("div", { staticClass: "form-inline" }, [
                    _c("label", { attrs: { for: "todos" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.todos,
                            expression: "form.todos"
                          }
                        ],
                        attrs: { type: "checkbox", name: "todos", id: "todos" },
                        domProps: {
                          checked: Array.isArray(_vm.form.todos)
                            ? _vm._i(_vm.form.todos, null) > -1
                            : _vm.form.todos
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = _vm.form.todos,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.form,
                                      "todos",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.form,
                                      "todos",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.form, "todos", $$c)
                              }
                            },
                            _vm.changeTodos
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Todas las personas")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.filtro === "C",
                            expression: "form.filtro === 'C'"
                          }
                        ],
                        attrs: { for: "conDetalles" }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.conDetalles,
                              expression: "form.conDetalles"
                            }
                          ],
                          attrs: {
                            type: "checkbox",
                            name: "conDetalles",
                            id: "conDetalles"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.form.conDetalles)
                              ? _vm._i(_vm.form.conDetalles, null) > -1
                              : _vm.form.conDetalles
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = _vm.form.conDetalles,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.form,
                                        "conDetalles",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.form,
                                        "conDetalles",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.form, "conDetalles", $$c)
                                }
                              },
                              _vm.changeConDetalles
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Mostrar detalles del comp.")])
                      ]
                    ),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "pendientesPago" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.pendientesPago,
                            expression: "form.pendientesPago"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          name: "pendientesPago",
                          id: "pendientesPago"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.form.pendientesPago)
                            ? _vm._i(_vm.form.pendientesPago, null) > -1
                            : _vm.form.pendientesPago
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = _vm.form.pendientesPago,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.form,
                                      "pendientesPago",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.form,
                                      "pendientesPago",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.form, "pendientesPago", $$c)
                              }
                            },
                            _vm.changePendientesPago
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Mostrar pendientes de pago")])
                    ]),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "pagados" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.pagados,
                            expression: "form.pagados"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          name: "pagados",
                          id: "pagados"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.form.pagados)
                            ? _vm._i(_vm.form.pagados, null) > -1
                            : _vm.form.pagados
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = _vm.form.pagados,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.form,
                                      "pagados",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.form,
                                      "pagados",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.form, "pagados", $$c)
                              }
                            },
                            _vm.changePagados
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Mostrar pagados")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.form.filtro === "C",
                            expression: "form.filtro === 'C'"
                          }
                        ],
                        attrs: { for: "abonados" }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.abonados,
                              expression: "form.abonados"
                            }
                          ],
                          attrs: {
                            type: "checkbox",
                            name: "abonados",
                            id: "abonados"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.form.abonados)
                              ? _vm._i(_vm.form.abonados, null) > -1
                              : _vm.form.abonados
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = _vm.form.abonados,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.form,
                                        "abonados",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.form,
                                        "abonados",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.form, "abonados", $$c)
                                }
                              },
                              _vm.changeConAbonos
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Mostrar abonos")])
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-field select2" },
                    [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("v-select", {
                            attrs: {
                              id: "tiposAbono",
                              options: _vm.tiposAbono,
                              label: "nombre",
                              placeholder: "Seleccione...",
                              multiple: ""
                            },
                            on: { input: _vm.inputTiposAbono },
                            model: {
                              value: _vm.selectedTiposAbono,
                              callback: function($$v) {
                                _vm.selectedTiposAbono = $$v
                              },
                              expression: "selectedTiposAbono"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "tiposAbono" } }, [
                            _vm._v("Tipos de abono")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.form.tipos_abono, function(tipoAbono) {
                        return _c("input", {
                          key: tipoAbono,
                          attrs: { type: "hidden", name: "tipos_abono[]" },
                          domProps: { value: tipoAbono }
                        })
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-8" }, [
                  _c("div", { staticClass: "form-inline" }, [
                    _c("div", { staticClass: "form-field select" }, [
                      _c("div", { staticClass: "select-field" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.tipo_fecha,
                                expression: "form.tipo_fecha"
                              }
                            ],
                            attrs: { name: "tipo_fecha", id: "tipo_fecha" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.form,
                                  "tipo_fecha",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "C" } }, [
                              _vm._v("Fecha de comprobante")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "A" } }, [
                              _vm._v("Fecha de abonos")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "F" } }, [
                              _vm._v("Fecha de caducidad")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "tipo_fecha" } }, [
                          _vm._v("Tipo de fecha")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._m(2),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "hoy" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.tipoFecha,
                            expression: "form.tipoFecha"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          name: "tipoFecha",
                          id: "hoy",
                          value: "H"
                        },
                        domProps: { checked: _vm._q(_vm.form.tipoFecha, "H") },
                        on: {
                          change: function($event) {
                            return _vm.$set(_vm.form, "tipoFecha", "H")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Hoy")])
                    ]),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "ayer" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.tipoFecha,
                            expression: "form.tipoFecha"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          name: "tipoFecha",
                          id: "ayer",
                          value: "A"
                        },
                        domProps: { checked: _vm._q(_vm.form.tipoFecha, "A") },
                        on: {
                          change: function($event) {
                            return _vm.$set(_vm.form, "tipoFecha", "A")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Ayer")])
                    ]),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "rango" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.tipoFecha,
                            expression: "form.tipoFecha"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          name: "tipoFecha",
                          id: "rango",
                          value: "R"
                        },
                        domProps: { checked: _vm._q(_vm.form.tipoFecha, "R") },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(_vm.form, "tipoFecha", "R")
                            },
                            _vm.changeFechas
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Filtrar por fechas")])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.tipoFecha === "R",
                          expression: "form.tipoFecha === 'R'"
                        }
                      ],
                      staticClass: "form-field"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "datepicker-field datepicker-field--stretch"
                        },
                        [
                          _c("date-picker", {
                            attrs: {
                              name: "fechaDesde",
                              type: "date",
                              format: "dd-MM-yyyy",
                              id: "desde",
                              lang: "es"
                            },
                            model: {
                              value: _vm.form.fechaDesde,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "fechaDesde", $$v)
                              },
                              expression: "form.fechaDesde"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", [_vm._v("Desde")])
                        ],
                        1
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.tipoFecha === "R",
                          expression: "form.tipoFecha === 'R'"
                        }
                      ],
                      staticClass: "form-field"
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.tipoFecha === "R",
                              expression: "form.tipoFecha === 'R'"
                            }
                          ],
                          staticClass:
                            "datepicker-field datepicker-field--stretch"
                        },
                        [
                          _c("date-picker", {
                            attrs: {
                              name: "fechaHasta",
                              type: "date",
                              format: "dd-MM-yyyy",
                              id: "hasta",
                              lang: "es"
                            },
                            model: {
                              value: _vm.form.fechaHasta,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "fechaHasta", $$v)
                              },
                              expression: "form.fechaHasta"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", [_vm._v("Hasta")])
                        ],
                        1
                      )
                    ]
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _vm.filtroActual === "C"
            ? _c("tabla-reporte-ventas", {
                attrs: {
                  diasAlerta: _vm.diasAlerta,
                  conAbonos: _vm.form.abonados,
                  conDetalles: _vm.form.conDetalles,
                  registros: _vm.registros
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.filtroActual === "L"
            ? _c("tabla-logs-reporte-ventas", { attrs: { logs: _vm.logs } })
            : _vm._e(),
          _vm._v(" "),
          _vm.filtroActual === "C"
            ? _c("div", { staticClass: "card mt-2" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "card__content" }, [
                  _c("div", { staticClass: "table-responsive" }, [
                    _c("table", [
                      _vm._m(4),
                      _vm._v(" "),
                      _c("tbody", [
                        _c("tr", [
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.moneyFormat(_vm.totales.total_sin_impuestos)
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.moneyFormat(_vm.totales.total_iva))
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.moneyFormat(_vm.totales.total_ice))
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.moneyFormat(_vm.totales.total_irbpnr))
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.moneyFormat(_vm.totales.total_ret_iva))
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.moneyFormat(_vm.totales.total_ret_renta)
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.moneyFormat(_vm.totales.total_comprobantes)
                              )
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "modal",
            {
              attrs: {
                height: "auto",
                width: "70%",
                name: "cliente",
                scrollable: ""
              }
            },
            [
              _c("lista-personas", {
                attrs: { filterStatus: false },
                on: { selected: _vm.selectedPersona }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Reporte de comprobantes")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información de la consulta")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("p", [_c("strong", [_vm._v("Fecha:")])])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Totales generales")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Tot. Sin Imp.")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tot. IVA")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tot. ICE")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tot. IRBPNR")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tot. Ret. IVA")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tot. Ret. Renta")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tot. Comp.")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c86f03bc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c86f03bc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/reportes/ReporteVentas.vue
// module id = 487
// module chunks = 0